<template>
  <div>溯源详情</div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>

</style>
